import React from "react";

export default class Ping extends React.Component<{}, {}> {

    render() {
        return <div>pong</div>
    }

}
